import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducer";

const PanelBody = ({children}) => {

    const State = useSelector((state: RootState) => state);
    // ${State.menuHidden ? " sided" : ""}
    return(
        <div className="panelContainer sided">
            <div className="panelBody">
                {children}
            </div>
        </div>
    )
}

export default PanelBody;